import { Link } from 'react-router-dom';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { Header } from './styles';

interface ListHeaderInterface {
  doesListExists: boolean;
  hasError: boolean;
  filteredListLength: number;
  singularLabel: string;
  pluralLabel: string;
  downloadExcel: () => void;
}

export default function ListHeader({
  doesListExists,
  hasError,
  filteredListLength,
  singularLabel,
  pluralLabel,
  downloadExcel,
}: ListHeaderInterface) {
  const { permissions } = useGetGeneralAppData();
  const clientUsersPermissions = permissions.find((x) => x.codPag === 3);

  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists} apiFetched={!hasError}>
        {(doesListExists) && (
          <div className="leftAlignment">
            <strong>
              {filteredListLength}
              {' '}
              {filteredListLength === 1 ? singularLabel : pluralLabel}
            </strong>
          </div>
        )}
        <div className="actionButtons">
          {clientUsersPermissions?.incluir && (
            <Link to="/clientUsers/new">
              Novo Usuário
            </Link>
          )}
          <button type='button' onClick={() => downloadExcel()}>Download XLSX</button>
        </div>
      </Header>
    </OpacityAnimation>
  );
}
